import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';



class Classes extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='Classes'>
      <div><Link to='/'>Home</Link></div>
      <h3>Aikido Tuksom RomKlao Dojo's Classes</h3>

      <br />
      <br />

        <div><Link to='/rostertuksom'>Friday 18.30-20.00</Link></div>
        <br />
        <div><Link to='/rostertuksom'>Saturday 10.00-12.00</Link></div>
        <br />
        <div><Link to='/rostertuksom'>Sunday 10.00-12.00</Link></div>

        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Classes;
